import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-sidebar-onboarding',
  templateUrl: './sidebar-onboarding.component.html',
  styleUrls: ['./sidebar-onboarding.component.sass']
})
export class SidebarOnboardingComponent implements OnInit {
  constructor() { }

  ngOnInit() {
  }
}
